// extracted by mini-css-extract-plugin
export default {"mainContainer":"Posts_mainContainer__xNRwj"};